module.exports = __webpack_public_path__ + "img/TEXT_WITH_TITLE.184ac7db.svg";